module.exports = __webpack_public_path__ + "img/banner-1-m.cbaab36c.jpg";